import React, { Component } from "react";
import Modal from "react-modal";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import IGetMaterialsDTO from "../../../models/DTO/IGetMaterialsDTO";
import IMaterialsGetBulkImportCsvDTO from "../../../models/DTO/IMaterialsGetBulkImportCsvDTO";
import IMaterialsOnGetBulkImportCsvDTO from "../../../models/DTO/IMaterialsOnGetBulkImportCsvDTO";
import IOnGetMaterialsDTO from "../../../models/DTO/IOnGetMaterialsDTO";
import IOnProcessMaterialDTO from "../../../models/DTO/IOnProcessMaterialDTO";
import IProcessMaterialDTO from "../../../models/DTO/IProcessMaterialDTO";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IBreadcrumbs from "../../../models/IBreadcrumbs";
import IMaterial from "../../../models/IMaterial";
import INotification from "../../../models/INotification";
import IOwTableCols from "../../../models/IOwTableCols";
import ISupplierModel from "../../../models/ISupplierModel";
import IUserUI from "../../../models/IUserUI";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import Breadcrumbs from "../../shared/Breadcrumbs/Breadcrumbs";
import OwButton from "../../shared/OwButton/OwButton";
import { OwIconButton } from "../../shared/OwIconButton/OwIconButton";
import OwTable from "../../shared/OwTable/OwTable";
import OwTitle from "../../shared/OwTitle/OwTitle";
import MaterialSidebar from "../MaterialSidebar/MaterialSidebar";
import MaterialsUploadCsvModal from "../MaterialsUploadCsvModal/MaterialsUploadCsvModal";
import { Socket } from "socket.io-client";

type Props = {
    userModel: IUserUI;
    supplierModel: ISupplierModel;
    notifyFn: (data: IErrorDTO | null, _notification?: any, isFormatted?: boolean) => void;
    socket: Socket;
    toggleSidebar: (shouldBeVisible?: boolean) => void;
    setSidebarComponent: (component: any) => void;
    setActivityIndicator: (activityOn: boolean) => void;
};

type State = {
    breadcrumbs: IBreadcrumbs[];
    columns: IOwTableCols[];
    dataSet: any[];
    dataIsFetching: boolean;
    isInitialData: boolean;
    modalComponent: any;
    modalIsOpen: boolean;
};

class Materials extends Component<Props, State> {
    constructor(props: any) {
        super(props);

        this.state = {
            breadcrumbs: [
                { title: "Dashboard", url: "/dashboard" },
                { title: "Materials", url: "/materials" },
            ],
            columns: [
                { title: "", valueProp: "", isActionsCol: true, renderFn: this.actionCol, className: "w-5r" },
                { title: "name", valueProp: "name" },
                {
                    title: "qty_on_hand",
                    valueProp: "qty_on_hand",
                    renderFn: this.renderQtyOnHand,
                    renderFnEmitsRow: true,
                },
            ],
            dataSet: [],
            dataIsFetching: false,
            isInitialData: false,
            modalComponent: null,
            modalIsOpen: false,
        };
    }

    componentDidMount(): void {
        this.props.socket.on(EndpointsEnum.MaterialOnGetMaterials, this.onGetMaterials);
        this.props.socket.on(EndpointsEnum.MaterialOnProcessMaterial, this.onProcessMaterials);
        this.props.socket.on(EndpointsEnum.MaterialOnGetBulkImportCSV, this.onDownloadCsv);

        this.getMaterials();
    }

    componentWillUnmount(): void {
        this.props.socket.removeListener(EndpointsEnum.MaterialOnGetMaterials, this.onGetMaterials);
        this.props.socket.removeListener(EndpointsEnum.MaterialOnProcessMaterial, this.onProcessMaterials);
        this.props.socket.removeListener(EndpointsEnum.MaterialOnGetBulkImportCSV, this.onDownloadCsv);
    }

    renderQtyOnHand = (row: IMaterial) => {
        return <div>{row.qty_on_hand}</div>;
    };

    actionCol = (row: IMaterial) => {
        return (
            <div>
                <OwIconButton
                    iconClass={"far fa-trash-alt"}
                    iconColorClass={"text-danger me-2"}
                    fn={() => {
                        this.deleteMaterial(row);
                    }}
                />
                <OwIconButton
                    iconClass={"far fa-pencil"}
                    iconColorClass={"text-primary"}
                    fn={() => {
                        this.openSidebar(row);
                    }}
                />
            </div>
        );
    };

    deleteMaterial = (row: IMaterial) => {
        const payload: IProcessMaterialDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            deleteFlag: true,
            material: row,
        };

        this.props.socket.emit(EndpointsEnum.MaterialProcessMaterial, payload);
    };

    onProcessMaterials = (data: IOnProcessMaterialDTO) => {
        this.getMaterials();
    };

    toggleSidebar = (shouldBeVisible?: boolean) => {
        this.props.toggleSidebar(shouldBeVisible);

        this.getMaterials();
    };

    openSidebar = (material?: IMaterial) => {
        const sidebar = (
            <MaterialSidebar
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                toggleSidebar={this.toggleSidebar}
                material={material}
            />
        );
        this.props.setSidebarComponent(sidebar);
        this.props.toggleSidebar();
    };

    getMaterials = () => {
        const payload: IGetMaterialsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.MaterialGetMaterials, payload);
    };

    onGetMaterials = (data: IOnGetMaterialsDTO) => {
        this.setState({
            dataSet: data.materials,
        });
    };

    downloadCsv = () => {
        const payload: IMaterialsGetBulkImportCsvDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
        };

        this.props.socket.emit(EndpointsEnum.MaterialGetBulkImportCSV, payload);
    };

    downloadCSVData = (csvData: any, filename: string) => {
        const blob = new Blob([csvData], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        link.download = filename;
        link.click();
    };

    onDownloadCsv = (data: IMaterialsOnGetBulkImportCsvDTO) => {
        this.downloadCSVData(data.csvData, data.filename);
    };

    closeModalFn = (refresh?: boolean) => {
        this.setState(
            {
                modalComponent: null,
                modalIsOpen: false,
            },
            () => {
                if (refresh) {
                    this.getMaterials();
                }
            }
        );
    };

    uploadCsv = () => {
        const component = (
            <MaterialsUploadCsvModal
                closeModalFn={this.closeModalFn}
                socket={this.props.socket}
                notifyFn={this.props.notifyFn}
                userModel={this.props.userModel}
                supplierModel={this.props.supplierModel}
            />
        );

        this.setState({
            modalComponent: component,
            modalIsOpen: true,
        });
    };

    render() {
        return (
            <div className="Materials">
                {/*<Breadcrumbs crumbs={this.state.breadcrumbs} />*/}

                <div className={"d-flex align-items-center mt-2"}>
                    <OwTitle title={"materials"} leftIconName={"fad fa-cubes"} className={"me-2"} />

                    <div>
                        <OwButton
                            title={"create"}
                            leftIconClass={"far fa-plus"}
                            fn={() => {
                                this.openSidebar();
                            }}
                        />
                    </div>

                    <div className={"ms-auto"}>
                        <OwButton title={"download_csv_upload"} leftIconClass={"fad fa-download"} fn={this.downloadCsv} />
                        <OwButton className={"ms-2 btn-danger"} title={"upload_csv"} leftIconClass={"fad fa-upload"} fn={this.uploadCsv} />
                    </div>
                </div>

                <div></div>

                <div>
                    <OwTable
                        columns={this.state.columns}
                        dataSet={this.state.dataSet}
                        userModel={this.props.userModel}
                        supplierModel={this.props.supplierModel}
                        dataFetch={this.state.dataIsFetching}
                        initialData={this.state.isInitialData}
                    />
                </div>

                <div>
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        contentLabel="Orderwerks"
                        shouldCloseOnOverlayClick={false}
                        className={"modalContentClass"}
                        overlayClassName={"modalOverlayClass"}>
                        {this.state.modalComponent}
                    </Modal>
                </div>
            </div>
        );
    }
}

export default Materials;
